module.exports = __webpack_public_path__ + "static/img-slide-4-mobile-3282fe0713881e4af35e9c4d4219bd67.png";